export enum PageActionTypes {
  SET_THREE_MODE = 'SET_THREE_MODE',
}
